"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var Help_1 = __importDefault(require("@material-ui/icons/Help"));
var InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
var config_1 = require("@pbl/pbl-react-web-components/lib/config/config");
var TextFieldValidator_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/field/TextFieldValidator"));
var Icon_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/icon/Icon"));
var TicketInputMask_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/ticket-entry/TicketInputMask"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var yup = __importStar(require("yup"));
var typography_1 = require("../../../shared/theme/typography");
var styles_1 = __importDefault(require("./styles"));
var TicketCardContent = function (props) {
    var _a, _b, _c, _d, _e;
    var t = (0, react_i18next_1.useTranslation)().t;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme, props.customerVariant)();
    var ticketTab = props.ticketTab, onSubmit = props.onSubmit, showSampleTicketHelpImage = props.showSampleTicketHelpImage, navigateToGames = props.navigateToGames, loading = props.loading, successfulEntered = props.successfulEntered, showConsentText = props.showConsentText, label = props.label, tabLogo = props.tabLogo, tabAltText = props.tabAltText, tabIndex = props.tabIndex, ticketFieldsData = props.ticketFieldsData, isRestricted = props.isRestricted, handleContactUs = props.handleContactUs, customerVariant = props.customerVariant, titleRefs = props.titleRefs, contentRefs = props.contentRefs, cardIndex = props.cardIndex;
    var _f = (0, react_1.useState)(false), formIsValid = _f[0], setFormIsValid = _f[1];
    var _g = (0, react_1.useState)((_a = ticketFieldsData === null || ticketFieldsData === void 0 ? void 0 : ticketFieldsData.ticketBarcodeNumber) !== null && _a !== void 0 ? _a : ''), ticketBarcodeNumber = _g[0], setTicketBarcodeNumber = _g[1];
    var _h = (0, react_1.useState)((_b = ticketFieldsData === null || ticketFieldsData === void 0 ? void 0 : ticketFieldsData.validationNumber) !== null && _b !== void 0 ? _b : ''), validationNumber = _h[0], setValidationNumber = _h[1];
    var _j = (0, react_1.useState)((_c = ticketFieldsData === null || ticketFieldsData === void 0 ? void 0 : ticketFieldsData.tabKey) !== null && _c !== void 0 ? _c : ''), tabKey = _j[0], setTabKey = _j[1];
    var _k = (0, react_1.useState)({}), focusedFields = _k[0], setFocusedFields = _k[1];
    var ticketInputRef = (0, react_1.useRef)(null);
    var entryCodInputRef = (0, react_1.useRef)(null);
    var showMessage = (0, react_redux_1.useSelector)(function (state) { return state.app; }).showMessage;
    var _l = react_1.default.useState(undefined), maxTitleHeight = _l[0], setMaxTitleHeight = _l[1];
    var _m = react_1.default.useState(undefined), maxContentHeight = _m[0], setMaxContentHeight = _m[1];
    (0, react_1.useEffect)(function () {
        if (customerVariant !== 'ks')
            return;
        var titleObservers = [];
        var contentObservers = [];
        var areAllEqual = function (arr) { return arr.every(function (val) { return val === arr[0]; }); };
        var updateHeights = function () {
            var titleHeights = titleRefs.current.map(function (el) { var _a; return (_a = el === null || el === void 0 ? void 0 : el.getBoundingClientRect().height) !== null && _a !== void 0 ? _a : 0; });
            var contentHeights = contentRefs.current.map(function (el) { var _a; return (_a = el === null || el === void 0 ? void 0 : el.getBoundingClientRect().height) !== null && _a !== void 0 ? _a : 0; });
            var newMaxTitleHeight = Math.max.apply(Math, titleHeights);
            var newMaxContentHeight = Math.max.apply(Math, contentHeights);
            if (!areAllEqual(titleHeights)) {
                setMaxTitleHeight(newMaxTitleHeight);
            }
            if (!areAllEqual(contentHeights)) {
                setMaxContentHeight(newMaxContentHeight);
            }
        };
        titleRefs.current.forEach(function (ref) {
            if (ref) {
                var observer = new ResizeObserver(updateHeights);
                observer.observe(ref);
                titleObservers.push(observer);
            }
        });
        contentRefs.current.forEach(function (ref) {
            if (ref) {
                var observer = new ResizeObserver(updateHeights);
                observer.observe(ref);
                contentObservers.push(observer);
            }
        });
        updateHeights();
        return function () {
            titleObservers.forEach(function (obs) { return obs.disconnect(); });
            contentObservers.forEach(function (obs) { return obs.disconnect(); });
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (successfulEntered) {
            setTicketBarcodeNumber('');
            setValidationNumber('');
            setTabKey('');
            setFormIsValid(false);
        }
    }, [successfulEntered]);
    var handleContactUsLink = function (e) {
        e.preventDefault();
        handleContactUs === null || handleContactUs === void 0 ? void 0 : handleContactUs();
    };
    var handleMouseDown = function (event) {
        event.preventDefault();
    };
    var handleFieldValueChange = function (attr, isNumbersOnly, withSpecialCharacters, fieldLabel, minLength) { return function (event) {
        var inputVal = event.target.value || '';
        var value;
        if (isNumbersOnly) {
            value = inputVal.replace(/\D+/g, '');
        }
        else if (withSpecialCharacters) {
            value = inputVal.replace(/[^a-zA-Z0-9#%&]+/g, '');
        }
        else {
            value = inputVal.replace(/[^a-zA-Z0-9]+/g, '');
        }
        if (value.length === minLength &&
            config_1.config.internalConfig.TICKET_FOCUS_NEXT_FIELD &&
            attr === 'ticketBarcodeNumber' &&
            entryCodInputRef.current) {
            entryCodInputRef.current.focus();
        }
        var newFormIsValid = false;
        if (ticketTab.fields.length === 1 &&
            customerVariant === 'ks' &&
            t(fieldLabel).toLowerCase() === 'webcode') {
            newFormIsValid =
                value.length >= ticketTab.fields[0].min && !value.toLowerCase().includes('o');
        }
        else if (ticketTab.fields.length === 1) {
            newFormIsValid = value.length >= ticketTab.fields[0].min;
        }
        else if (attr === 'ticketBarcodeNumber') {
            newFormIsValid =
                value.length >= ticketTab.fields[0].min &&
                    validationNumber.length >= ticketTab.fields[1].min;
        }
        else {
            newFormIsValid =
                value.length >= ticketTab.fields[1].min &&
                    ticketBarcodeNumber.length >= ticketTab.fields[0].min;
        }
        if (attr === 'ticketBarcodeNumber') {
            setTicketBarcodeNumber(value);
        }
        else {
            setValidationNumber(value);
        }
        setTabKey('');
        setFormIsValid(newFormIsValid);
    }; };
    var handleOnBlur = (0, react_1.useCallback)(function (fieldLabel) {
        var newFormIsValid = false;
        if (ticketTab.fields.length > 1) {
            newFormIsValid = yup
                .object()
                .shape({
                ticketBarcodeNumber: yup
                    .string()
                    .required()
                    .min(ticketTab.fields[0].min),
                validationNumber: yup
                    .string()
                    .required()
                    .min(ticketTab.fields[1].min)
            })
                .isValidSync({ ticketBarcodeNumber: ticketBarcodeNumber, validationNumber: validationNumber });
        }
        else {
            if (customerVariant === 'ks' && t(fieldLabel).toLowerCase() === 'webcode') {
                newFormIsValid = yup
                    .object()
                    .shape({
                    ticketBarcodeNumber: yup
                        .string()
                        .required()
                        .min(ticketTab.fields[0].min)
                        .test('no-o-characters', 'Cannot contain the letter "o" or "O"', function (value) { return !value || !/[oO]/.test(value); })
                })
                    .isValidSync({ ticketBarcodeNumber: ticketBarcodeNumber });
            }
            else {
                newFormIsValid = yup
                    .object()
                    .shape({
                    ticketBarcodeNumber: yup
                        .string()
                        .required()
                        .min(ticketTab.fields[0].min)
                })
                    .isValidSync({ ticketBarcodeNumber: ticketBarcodeNumber });
            }
        }
        setFormIsValid(newFormIsValid);
    }, [ticketTab, ticketBarcodeNumber, validationNumber]);
    var handleOnSubmitBtn = function (key) {
        if (formIsValid) {
            onSubmit(ticketBarcodeNumber, validationNumber, key);
            setTicketBarcodeNumber('');
            setValidationNumber('');
            setFormIsValid(false);
        }
    };
    var getFieldValue = function (index, currentTabKey) {
        if (tabKey === 'scratchTicket' && currentTabKey === 'scratchTicket') {
            return index > 0 ? validationNumber : ticketBarcodeNumber;
        }
        if ((tabKey === 'drawTicket' && currentTabKey === 'drawTicket') ||
            (tabKey === 'quickCard' && currentTabKey === 'quickCard')) {
            return ticketBarcodeNumber;
        }
        return index > 0 ? validationNumber : ticketBarcodeNumber;
    };
    var getHelperText = function (field, index, codeDisclaimer) {
        var fieldValue = getFieldValue(index, ticketTab.tabKey);
        var fieldLabel = t(field.label).toLowerCase();
        if (fieldValue.length > 0 && fieldValue.length < field.min && !focusedFields[field.key]) {
            return field.errorText
                ? t(field.errorText)
                : t('field.error', 'Please enter a valid ' + fieldLabel, { fieldLabel: fieldLabel });
        }
        else if (fieldValue.length > 0 &&
            customerVariant === 'ks' &&
            fieldLabel === 'webcode' &&
            fieldValue.toLowerCase().includes('o')) {
            return codeDisclaimer;
        }
        else if (fieldValue.length > 0 && fieldValue.length < field.min && customerVariant === 'ks') {
            return t('Please enter a valid ' + fieldLabel, { fieldLabel: fieldLabel });
        }
        return customerVariant === 'ks' ? codeDisclaimer : field.placeholder;
    };
    var getValidationSchema = function (field) {
        var fieldLabel = t(field.label).toLowerCase();
        if (customerVariant === 'ks' && fieldLabel === 'webcode') {
            return yup
                .string()
                .notRequired()
                .test('webcode-validation', 'Must be at least min characters and cannot contain the letter "O"', function (value) {
                if (!value)
                    return true;
                if (value.length < field.min)
                    return false;
                if (customerVariant === 'ks' && /[oO]/.test(value))
                    return false;
                return true;
            });
        }
        return yup
            .string()
            .notRequired()
            .test('minLength', 'Must be at least min character', function (value) { return !value || value.length >= field.min; });
    };
    if (!ticketTab)
        return null;
    return (react_1.default.createElement(core_1.Card, { className: classes.ticketCardContent },
        react_1.default.createElement("div", { className: classes.ticketTitle },
            tabLogo && (react_1.default.createElement("img", { alt: tabAltText, src: tabLogo, style: { margin: 'auto', height: '70px' } })),
            react_1.default.createElement("div", { ref: function (el) { return (titleRefs.current[cardIndex] = el); }, style: customerVariant === 'ks' ? { height: maxTitleHeight } : undefined },
                react_1.default.createElement(core_1.Typography, { align: "center", component: "h3", className: classes.cardLabelStyle }, label)),
            customerVariant !== 'ks' && (react_1.default.createElement(core_1.Typography, { style: {
                    textAlign: 'start',
                    fontFamily: typography_1.themeFonts.Roboto,
                    fontSize: '16px'
                } }, t('ticketEntryPage.requiredInfo'))),
            !isRestricted ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { ref: function (el) { return (contentRefs.current[cardIndex] = el); }, className: classes.inputListSection, style: customerVariant === 'ks' ? { height: maxContentHeight } : undefined }, ticketTab.fields.map(function (field, index) { return (react_1.default.createElement("div", { key: field.key, className: classes.flexDirectionColumn },
                    react_1.default.createElement("label", { htmlFor: field.key, className: classes.labelCenter },
                        react_1.default.createElement(core_1.Typography, { component: "span", variant: "srOnly" }, ticketTab.tabKey),
                        react_1.default.createElement(core_1.Typography, { component: "span", variant: "subtitle2", color: "textSecondary", align: "center", style: {
                                fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.SFProRegular : typography_1.themeFonts.Roboto,
                                fontWeight: customerVariant === 'ks' ? 'normal' : undefined,
                                fontSize: '16px'
                            } }, t(field.label))),
                    react_1.default.createElement(TextFieldValidator_1.default, { InputProps: {
                            startAdornment: ticketTab.tabKey === 'quickCard' ? (react_1.default.createElement(core_1.InputAdornment, { position: "start", className: classes.inputAdornment }, "639299")) : null,
                            inputComponent: TicketInputMask_1.default[field.maskKey],
                            classes: { input: classes.input }
                        }, inputProps: {
                            'aria-required': 'true',
                            autoComplete: 'off',
                            style: {
                                textTransform: 'uppercase',
                                fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.SFProRegular : undefined,
                                padding: customerVariant === 'ks' ? theme.spacing(1, 1.5) : undefined
                            }
                        }, id: field.key, value: getFieldValue(index, ticketTab.tabKey), onChange: handleFieldValueChange(index > 0 ? 'validationNumber' : 'ticketBarcodeNumber', field.numbersOnly, field.withSpecialCharacters, field.label, field.min), onFocus: function () { return setFocusedFields(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[field.key] = true, _a)));
                        }); }, onBlur: function () {
                            handleOnBlur(field.label);
                            setFocusedFields(function (prev) {
                                var _a;
                                return (__assign(__assign({}, prev), (_a = {}, _a[field.key] = false, _a)));
                            });
                        }, placeholder: customerVariant === 'ks' ? field.placeholder : undefined, className: (0, classnames_1.default)(classes.spacing), variant: config_1.config.internalConfig.FIELDS_VARIANT, validationSchema: getValidationSchema(field), type: "text", inputRef: index === 0 ? ticketInputRef : entryCodInputRef, helperText: getHelperText(field, index, ticketTab.codeDisclaimer ? t(ticketTab.codeDisclaimer) : undefined) }),
                    react_1.default.createElement("div", { "aria-live": "polite" }, !yup
                        .string()
                        .notRequired()
                        .test('minLength', 'Must be at least min character', function (value) { return !value || value.length >= field.min; })
                        .isValidSync(getFieldValue(index, ticketTab.tabKey)) && (react_1.default.createElement(core_1.Typography, { variant: "srOnly" }, getHelperText(field, index, ticketTab.codeDisclaimer ? t(ticketTab.codeDisclaimer) : undefined)))))); })),
                ticketTab.codeDisclaimer && customerVariant !== 'ks' && (react_1.default.createElement(core_1.Typography, { component: "span", variant: "subtitle2", color: "textSecondary", style: { textDecoration: 'none', textTransform: 'none', textAlign: 'left' } }, t(ticketTab.codeDisclaimer))),
                react_1.default.createElement(core_1.Tooltip, { title: "Where do I find these numbers?", disableFocusListener: true },
                    react_1.default.createElement(core_1.Button, { variant: "text", color: "primary", onClick: function () { return showSampleTicketHelpImage(ticketTab.tabKey); }, className: classes.tooltipButton },
                        customerVariant === 'ks' ? (react_1.default.createElement(Help_1.default, { color: "primary", fontSize: "small", style: { marginRight: theme.spacing(1), flexShrink: 0 } })) : (react_1.default.createElement(InfoOutlined_1.default, { color: "primary", fontSize: "small", style: { marginRight: theme.spacing(1), flexShrink: 0 } })),
                        react_1.default.createElement(core_1.Typography, { component: "span", variant: "subtitle1", color: "primary", className: classes.tooltipText }, t(ticketTab.sampleImageLink)))),
                ticketTab.eligibleGamesEnabled && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.Typography, { style: {
                            fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.SFProRegular : undefined
                        }, component: "div", variant: "body1", color: "textPrimary", align: "center" }, t((_d = ticketTab.eligibleGameText) !== null && _d !== void 0 ? _d : '')),
                    ticketTab.eligibleGameLinkText && (react_1.default.createElement(core_1.Tooltip, { title: "See all eligible games", disableFocusListener: true, "aria-label": "See all eligible games" },
                        react_1.default.createElement(core_1.Button, { variant: "text", color: "primary", onClick: navigateToGames, "aria-label": t(ticketTab.eligibleGameLinkText || ''), className: (0, classnames_1.default)(classes.spacing, classes.ticketLink), onMouseDown: handleMouseDown },
                            !((_e = ticketTab === null || ticketTab === void 0 ? void 0 : ticketTab.eligibleGameLinkText) === null || _e === void 0 ? void 0 : _e.length) ? (react_1.default.createElement(Icon_1.default, { iconType: "material", iconName: "bookmark", color: "primary", fontSize: "small" })) : null,
                            react_1.default.createElement(core_1.Typography, { component: "span", variant: "subtitle1", color: "primary", style: {
                                    textDecoration: customerVariant === 'ks' ? 'underline' : 'none',
                                    textUnderlineOffset: '4px',
                                    textTransform: 'none',
                                    textAlign: 'center',
                                    fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.SatoshiBold : undefined
                                } }, t(ticketTab.eligibleGameLinkText || ''))))))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "subtitle1", style: {
                        fontWeight: 'bold',
                        marginBottom: customerVariant === 'ks' ? undefined : '24px',
                        textTransform: 'none',
                        fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.SFProRegular : undefined
                    }, align: "left" }, t('restriction.ticketEntryBlocked') !== 'restriction.ticketEntryBlocked'
                    ? t('restriction.ticketEntryBlocked')
                    : t('restriction.blocked')),
                react_1.default.createElement(core_1.Typography, { color: "textPrimary", variant: "body1", align: "left", style: { fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.SFProRegular : undefined } },
                    t('restriction.more'),
                    react_1.default.createElement(core_1.Link, { color: "textPrimary", underline: "always", onClick: handleContactUsLink, href: "#" }, t('restriction.contactUs')),
                    t('restriction.more2'))))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(core_1.Button, { size: "large", variant: "contained", color: config_1.config.internalConfig.BUTTON_BACKGROUND, className: (0, classnames_1.default)(classes.button, 'containedButton'), disabled: !formIsValid || loading, onClick: function () { return handleOnSubmitBtn(ticketTab.tabKey); }, "aria-label": "Submit", style: {
                    fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.Satoshi : undefined
                } }, "Submit"),
            showConsentText && (react_1.default.createElement(core_1.Typography, { component: "p", variant: "subtitle2", color: "primary", style: { textDecoration: 'none', textTransform: 'none', textAlign: 'center' } }, t(ticketTab.consentText ? ticketTab.consentText : ''))))));
};
exports.default = TicketCardContent;
//# sourceMappingURL=TicketCardContentV2.js.map